import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faPenNib, faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons'
import { faCircle, faCheckCircle } from '@fortawesome/free-regular-svg-icons'
import DisplayLevelComponent from './DisplayLevelComponent'
import { RichTextView } from './RichTextView'


interface CompetencyViewCardProps {
  title: string
  description: string
  evaluation: {
    isFocus?: boolean
    selfLevel?: number | null
    leaderLevel?: number | null
    showSelfAssessed?: boolean
    showGuided?: boolean
    status?: boolean
  }
  onClick: () => void
}

const CompetencyViewCard = ({
  title,
  description,
  evaluation,
  onClick,
}: CompetencyViewCardProps) => {
  const { isFocus, selfLevel, leaderLevel, showSelfAssessed, showGuided, status } = evaluation
  const statusIcon = status ? faCheckCircle : faCircle
  const statusClassName =
    status ? 'gw-competency-view-status-icon' : 'gw-competency-view-status-icon gw-competency-view-status-icon--pending'

  const showGuidedBadge = () => {
    return showGuided &&
      <span className="gw-competency-view-chip gw-competency-view-chip--guided">
        <FontAwesomeIcon icon={faPenNib} className="gw-competency-view-chip-icon" />
        Guided
      </span>
  }

  const showSelfAssessedBadge = () => {
    return showSelfAssessed &&
      <span className="gw-competency-view-chip gw-competency-view-chip--self">
        Self-assessed
      </span>
  }

  const showFocusBadge = () => {
    return isFocus &&
      <div className="gw-competency-view-focus-badge">
        <FontAwesomeIcon icon={faStarSolid} className="w-4 h-4" />
        Area of Focus
      </div>
  }

  return (
    <div
      className="card shadow-sm gw-competency-view-card"
      role="button"
      onClick={onClick}
    >
      <div className="card-body gw-competency-view-body">
        <div className="d-flex align-items-start gap-3">
          <FontAwesomeIcon icon={statusIcon} className={statusClassName} />
          <div className="flex-grow-1">
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <h6 className="gw-competency-view-title mb-0">{title}</h6>
              {showFocusBadge()}
              {showSelfAssessedBadge()}
              {showGuidedBadge()}
            </div>
            <RichTextView
              className="gw-competency-view-description mb-1"
              html={description}
            />
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <DisplayLevelComponent label="Self" level={selfLevel ?? null} />
              <DisplayLevelComponent className="gw-competency-view-level-value--guided" label="Guided" level={leaderLevel ?? null} />
            </div>
          </div>
          <FontAwesomeIcon icon={faChevronRight} className="gw-competency-view-chevron" />
        </div>
      </div>
    </div>
  )
}

export default React.memo(CompetencyViewCard)
